import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Fonts } from '$/components/core/Fonts';
import { LocalizationProvider } from '$/components/core/Localization/LocalizationProvider';
import { enablePiwik, enableSentry } from '$/logger';
import { router } from '$/routes';
import { queryClient } from '$/services/fetcher';
import { theme, config } from '$/theme';

import './theme/styles.css';

enablePiwik();
enableSentry();

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <ColorModeScript initialColorMode={config.initialColorMode} />
    <LocalizationProvider>
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <Fonts />
          <RouterProvider router={router} />
        </QueryClientProvider>
      </ChakraProvider>
    </LocalizationProvider>
  </StrictMode>,
);
